import React from "react";
import { motion } from "framer-motion";
import { waLink, WA } from "../../data/content";
import { WhatsappIcon } from "./Header";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink(WA.general)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 15 }}
    className="fixed bottom-5 right-5 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_28px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    <WhatsappIcon className="w-7 h-7 relative" />
  </motion.a>
);
